@if (itemsWithJsonData.length) {
    <app-table
        [items]="itemsWithJsonData"
        [columns]="columns"
        translatePrefix="form.dekn."
        [hideCheckboxes]="true"
        [resource]="resource"
        (detailCallback)="detail($event)"
        (deleteCallbackWithEvent)="delete($event)"
    >
        <ng-template pTemplate="printHeader"></ng-template>
        <ng-template pTemplate="print" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-print"
                (clickEvent)="print(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="copyHeader"></ng-template>
        <ng-template pTemplate="copy" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-copy"
                (clickEvent)="copy(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="abilityToCooperate" let-item="item">
            <span
                [pTooltip]="('form.dekn.abilityToCooperateOptions.' + evaluationNames[item.data.abilityToCooperate - 1]) | translate"
            >{{ item.data.abilityToCooperate }}</span>
        </ng-template>

        <ng-template pTemplate="age" let-item="item">
            <span
                [pTooltip]="('form.dekn.ageOptions.' + evaluationNames[item.data.age - 1]) | translate"
            >{{ item.data.age }}</span>
        </ng-template>

        <ng-template pTemplate="skinCondition" let-item="item">
            <span
                [pTooltip]="('form.dekn.skinConditionOptions.' + evaluationNames[item.data.skinCondition - 1]) | translate"
            >{{ item.data.skinCondition }}</span>
        </ng-template>

        <ng-template pTemplate="otherIllnesses" let-item="item">
            <span
                [pTooltip]="('form.dekn.otherIllnessesOptions.' + evaluationNames[item.data.otherIllnesses - 1]) | translate"
            >{{ item.data.otherIllnesses }}</span>
        </ng-template>

        <ng-template pTemplate="bodyCondition" let-item="item">
            <span
                [pTooltip]="('form.dekn.bodyConditionOptions.' + evaluationNames[item.data.bodyCondition - 1]) | translate"
            >{{ item.data.bodyCondition }}</span>
        </ng-template>

        <ng-template pTemplate="stateOfConsciousness" let-item="item">
            <span
                [pTooltip]="('form.dekn.stateOfConsciousnessOptions.' + evaluationNames[item.data.stateOfConsciousness - 1]) | translate"
            >{{ item.data.stateOfConsciousness }}</span>
        </ng-template>

        <ng-template pTemplate="activity" let-item="item">
            <span
                [pTooltip]="('form.dekn.activityOptions.' + evaluationNames[item.data.activity - 1]) | translate"
            >{{ item.data.activity }}</span>
        </ng-template>

        <ng-template pTemplate="mobility" let-item="item">
            <span
                [pTooltip]="('form.dekn.mobilityOptions.' + evaluationNames[item.data.mobility - 1]) | translate"
            >{{ item.data.mobility }}</span>
        </ng-template>

        <ng-template pTemplate="incontinence" let-item="item">
            <span
                [pTooltip]="('form.dekn.incontinenceOptions.' + evaluationNames[item.data.incontinence - 1]) | translate"
            >{{ item.data.incontinence }}</span>
        </ng-template>

    </app-table>
}
